module.exports = __webpack_public_path__ + "static/img/logo_lg_light.d64640b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_lg_light.png
// module id = hrEY
// module chunks = 0